import { DateneingabeBetrieblicheDatenKennzahlen } from '../../../DateneingabeBetrieblicheDatenKennzahlen';
import DialogWrapper2 from '../../../../../core/dialog/dialog_wrapper_v2';
import formStyle from '../../../../../core/forms/style/WForm.less';
import { IDs } from '../../../../../helpers/IDs';
import { lazyInject } from '../../../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../../../core/trigger/trigger_service';
import { WActionButton } from '../../../../../core/elements/WActionButton';

export interface KennzahlenButtonWrapperProps {
    forKomplexForm?: boolean;
    data: any;
    onChange?: () => void;
}

export interface KennzahlenButtonWrapperState {
    showDialog: string;
}

export class KennzahlenButtonWrapper extends React.Component<KennzahlenButtonWrapperProps, KennzahlenButtonWrapperState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showDialog: null,
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {
        const { forKomplexForm, onChange, data } = this.props;
        const { showDialog } = this.state;
        return (
            <div className={forKomplexForm ? formStyle.formCompact : null} style={{ display: 'inline-block' }}>
                <div style={{ display: 'flex' }}>
                    <WActionButton
                        styleProps={{ ...(forKomplexForm && { border: '1px solid var(--color-button-text)'}) }}
                        label={'Kennzahlen erfassen'}
                        tooltip={'Kennzahlen erfassen'}
                        insideText={!forKomplexForm && 'Kennzahlen erfassen'}
                        key='kennzahlen_new'
                        action='add'
                        onAction={() => this.setState({ showDialog: 'directAdd' })}
                    />
                    <WActionButton
                        styleProps={{ ...(forKomplexForm && { border: '1px solid var(--color-button-text)'}) }}
                        label={'Kennzahlen bearbeiten'}
                        tooltip={'Kennzahlen bearbeiten'}
                        insideText={!forKomplexForm && 'Kennzahlen bearbeiten'}
                        key='kennzahlen_all'
                        action='edit'
                        onAction={() => this.setState({ showDialog: 'normal' })}
                    />
                </div>
                {showDialog &&
                    <div>
                        <DialogWrapper2
                            width={800}
                            onAfterClose={() => {
                                this.setState({ showDialog: null });
                                if (showDialog !== 'directAdd') {
                                    this.triggerService.fire('reload', IDs.ENT_KENNZAHLEN_DYNAMISCH, () => {
                                        if (onChange) {
                                            onChange();
                                        }
                                    });
                                }
                            }}
                        >
                            <DateneingabeBetrieblicheDatenKennzahlen
                                onChange={onChange}
                                data={data}
                                parentElement={'KennzahlenButtonWrapper'}
                                directAddFormular={showDialog === 'directAdd'}
                                onClose={() => {
                                    if (showDialog === 'directAdd') {
                                        this.setState({ showDialog: null });
                                    }
                                }}
                            />
                        </DialogWrapper2>
                    </div>
                }
            </div>
        );
    }
}
